import * as React from 'react';
import * as ReactDom from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as $ from 'jquery';
import { Switch, Route } from 'react-router-dom';

import Categories from './components/categories/categories.component';
import CategoryArticles from './components/category-articles/category-articles.component';
import Embed from './components/embed/embed.component';
import { NotFound } from './components/notfound/notfound.component';

import './assets/css/no-index';

const initialState = typeof window['__INITIAL_STATE__'] !== 'undefined' ? window['__INITIAL_STATE__'] : { auth: { user: null }};
if (initialState.auth.user) {
    delete window['__INITIAL_STATE__'];
    $.ajaxSetup({ headers: { 'x-access-token': initialState.auth.user.token } });
}

import configureStore from './store/';

const store = configureStore(initialState);

ReactDom.render(
    <Provider store={store}>
        <HashRouter>
            <Switch>
                <Route path='/documents/:id' component={Embed} />
                <Route path='/categories/:alias' component={CategoryArticles} />
                <Route path='/' component={Categories} />
                <Route component={NotFound} />
            </Switch>
        </HashRouter>
    </Provider>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.tsx